import React from "react";
import { DependentHistoryList } from "components/dependent-history/DependentHistoryList";
import { Provider } from "components/dependent-history/DependentHistoryContext";

export const DependentHistories = () => {
    return (
        <Provider>
            <DependentHistoryList />
        </Provider>
    );
};
